import * as Sentry from '@sentry/react';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App, { getAsyncLDProvider } from './App';
import { store } from 'state/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';

const sentryEnabled = process.env.REACT_APP_SENTRY_ENABLED === 'true';

if (sentryEnabled) {
  Sentry.init({
    dsn: 'https://10d3169705f23cb802e821d7180f2104@o4507889185718272.ingest.us.sentry.io/4507890082381824',
    environment: process.env.REACT_APP_APP_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    // Tracing capture rate. Lowered from 0.75 — at 0.75 this project ingested
    // ~5.6M spans/30d (the #2 transaction-quota consumer in the org). 0.1 keeps
    // a representative sample.
    tracesSampleRate: 0.1,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/[^/]*cognota\.com\S*/],
    // Drop high-volume, no-signal errors that are bot/extension artifacts rather
    // than real app faults (the invalid-selector SyntaxError alone was ~85k events).
    ignoreErrors: [/is not a valid selector/],
  });
}

(async () => {
  const LDProvider = await getAsyncLDProvider();

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <LDProvider>
          <App />
        </LDProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
})();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
